import { Button } from '@mui/material';
import { useContext } from 'react';
import HelpOutline from '@mui/icons-material/HelpOutline';
import StepperContext from 'src/store/stepper-context';
import { colors } from 'src/styles/theme';

const buttonStyle = {
  color: colors.primary.main,
  cursor: 'pointer',
  fontSize: { xs: '0.5rem', sm: '0.75rem', md: '0.875rem' },
};

const helpIconStyle = {
  color: colors.primary.main,
  cursor: 'pointer',
  fontSize: { xs: '0.65rem', sm: '0.95rem', md: '1rem' },
  mr: '0.5rem',
};

/**
 * InfoButton is a component that displays a button with a help icon and opens a help modal when clicked.
 *
 * @returns {JSX.Element} - A JSX element representing the InfoButton component.
 */
const InfoButton = ({ text = 'Help' }) => {
  const { infoModalController } = useContext(StepperContext);

  return (
    <Button
      onClick={infoModalController.openModal}
      data-cy="help-button"
      variant="outlined"
      sx={buttonStyle}
    >
      <HelpOutline sx={helpIconStyle} />
      {text}
    </Button>
  );
};

export default InfoButton;
